let worker;

const setup = async () => {
  const { setupWorker } = await import('msw/browser');

  // should contain the list of the active handlers
  // for example, setupWorker(...handlers) will add all handlers to the worker
  // add only relevant handlers by importing them from the handlers file
  // for example: setupWorker(handlers[1], handlers[2])
  worker = setupWorker();

  await worker.start();
};

const browser = {
  setup,
  worker,
};

export default browser;
